import React, { useState } from "react";
import AuthShell from "@/components/AuthShell";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated");
      nav("/signin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Set a new password"
      subtitle="Enter the reset token you received and choose a new password."
      footer={<Link to="/signin" className="text-neu-accent font-semibold">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div>
          <label className="text-sm font-medium block mb-2">Reset token</label>
          <input
            required
            value={token}
            onChange={(e) => setToken(e.target.value)}
            className="neu-input font-mono text-xs"
            data-testid="reset-token"
          />
        </div>
        <div>
          <label className="text-sm font-medium block mb-2">New password</label>
          <input
            required
            type="password"
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="neu-input"
            data-testid="reset-password"
          />
        </div>
        <div>
          <label className="text-sm font-medium block mb-2">Confirm password</label>
          <input
            required
            type="password"
            minLength={6}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="neu-input"
            data-testid="reset-confirm"
          />
        </div>
        {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-xl">{error}</div>}
        <button type="submit" disabled={loading} className="btn-accent w-full" data-testid="reset-submit">
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>
    </AuthShell>
  );
}
